module.exports = __webpack_public_path__ + "img/level_logo1.bd9e739d.png";